export default function getList(translationCache, keyword) {
  return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
}

export function translation(keyword, translationCache) {
  return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
}